<template>
  <div>
    <v-row>
      <v-col cols="4">
        <div class="overline">Namn</div>
        <div class="body-1">{{ apprentice.firstName }} {{ apprentice.lastName }}</div>
      </v-col>
      <v-col cols="4">
        <div class="overline">Personnummer</div>
        <div class="body-1">
          {{
                showFullPersonalNumber
                  ? apprentice.personalNumber.substring(0, 8) + '-' + apprentice.personalNumber.substring(8, 12)
                  : maskedPersonalNumber
              }}
          <v-icon
            class="ml-2"
            @click="showPersonalnumber"
          >$sl-view-on</v-icon>
        </div>
      </v-col>
      <v-col cols="4"> </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <div class="overline">MOBILNUMMER</div>
        <div class="body-1">
          <a :href="'tel:' + apprentice.mobilephone">{{ apprentice.mobilephone }}</a>
        </div>
      </v-col>
      <v-col cols="4">
        <div class="overline">E-POSTADRESS</div>
        <div class="body-1">
          <a :href="'mailto:' + apprentice.email">{{ apprentice.email }}</a>
        </div>
      </v-col>
      <v-col cols="4">
        <div class="overline">Adress</div>
        <div class="body-1">{{ apprentice.address1 }}, {{ apprentice.zip }} {{ apprentice.city }}</div>
        <div class="body-1">{{ apprentice.address2 }}</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <template v-if="apprenticeMessage">
          <div class="overline">LÄRLINGEN BIFOGADE DETTA MEDDELANDE</div>
          <div
            class="body-1"
            v-html="apprenticeMessage"
          ></div>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import find from 'lodash/find'
import get from 'lodash/get'

export default {
  name: 'ApplicationApprenticeView',

  props: {
    apprentice: {
      type: Object,
      required: true
    },

    maskedPersonalNumber: {
      type: String,
      required: true
    }
  },

  data: () => ({
    showFullPersonalNumber: false
  }),

  computed: {
    ...mapGetters('application', ['selectedApplication']),

    apprenticeMessage() {
      if (this.selectedApplication) {
        const application = this.selectedApplication
        const message = find(get(application, 'notifications', []), function (m) {
          return Boolean(
            m.fromType === 'Person' &&
              m.fromPersonalNumber == application.personalNumber &&
              m.text.includes('Meddelande:')
          )
        })

        if (message) {
          return message.text.split('Meddelande: ').pop()
        }
      }
      return null
    }
  },

  methods: {

    /**
     * @vuese
     * Used to show mask to personal number
     */
    showPersonalnumber() {
      this.showFullPersonalNumber = true
      setTimeout(() => {
        this.showFullPersonalNumber = false
      }, 5000)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>